<template>
  <div class="dashboard pt-3">
    <!--<v-row align="center">
      <v-col class="text-center">
        <v-img src="../assets/2025-home-header.png" />
      </v-col>
    </v-row>-->
    
    <v-row v-if="members">
      <v-col>
        <div class="round-block bluee">
          <v-row class="text-center">
            <v-col cols="6" class="pb-1">
              <p class="mb-1"># of Participating People</p>
              <h1>{{ memberCount }}</h1>
            </v-col>
            <v-col cols="6" class="pb-1">
              <p class="mb-1"># of People Completed</p>
              <h1>{{ memberCompletedCount }}</h1>
            </v-col>
            <v-col cols="6" class="pt-1">
              <p class="mb-1">Total Amount Pledged</p>
              <h1>${{ memberDonationTotal }}</h1>
            </v-col>
            <v-col cols="6" class="pt-1">
              <p class="mb-1">Total Classes for Charity</p>
              <h1>{{ memberTotalClasses }}</h1>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <v-row v-if="memberLeaderboardLoading">
      <v-col class="text-center">
        <heart-loader />
      </v-col>
    </v-row>

    <v-row v-if="members && !memberLeaderboardLoading">
      <v-col>
        <v-tabs color="#A9421B" class="custom-tabs" fixed-tabs v-model="tab">
          <v-tab key="75">
            75 Classes
          </v-tab>
          <v-tab key="45">
            45 Classes
          </v-tab>
          <v-tab key="15">
            15 Classes
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" background-color="transparent">
          <v-tab-item :eager="true" key="75">
            <v-row>
              <v-col>
                <div class="leaderboard-table">
                  <div id="seventyfive" ref="seventyfive" class="scroll-view">
                    <v-simple-table fixed-header height="830">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Charity</th>
                          <th>Classes Completed</th>
                          <th>Days Remaining</th>
                        </tr>
                      </thead>
                      <tbody v-if="seventyfiveList && seventyfiveList.length > 0">
                        <tr class="body-row" v-for="member in seventyfiveList" :key="member.name">
                          <td>{{ formatName(member) }} </td>
                          <td><v-img style="max-width: 30px;" :src="require(`../assets/charities/${member.charityId}.png`)" /></td>
                          <td>{{ member.totalClasses }}</td>
                          <td>{{ daysRemaining(member.pledgeStartDate, member.pledgeEndDate) }}</td>
                        </tr>
                      </tbody>
                      <tbody v-if="!seventyfiveList || seventyfiveList.length === 0">
                        <td colspan="4" class="text-center">No pledges yet!</td>
                      </tbody>
                    </v-simple-table>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :eager="true" key="45">
            <v-row>
              <v-col>
                <div class="leaderboard-table">
                  <div id="fortyfive" ref="fortyfive" class="scroll-view">
                    <v-simple-table fixed-header height="830">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Charity</th>
                          <th>Classes Completed</th>
                          <th>Days Remaining</th>
                        </tr>
                      </thead>
                      <tbody v-if="fortyfiveList && fortyfiveList.length > 0">
                        <tr class="body-row" v-for="member in fortyfiveList" :key="member.name">
                          <td>{{ formatName(member) }} </td>
                          <td><v-img style="max-width: 30px;" :src="require(`../assets/charities/${member.charityId}.png`)" /></td>
                          <td>{{ member.totalClasses }}</td>
                          <td>{{ daysRemaining(member.pledgeStartDate, member.pledgeEndDate) }}</td>
                        </tr>
                      </tbody>
                      <tbody v-if="!fortyfiveList || fortyfiveList.length === 0">
                        <td colspan="4" class="text-center">No pledges yet!</td>
                      </tbody>
                    </v-simple-table>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :eager="true" key="15">
            <v-row>
              <v-col>
                <div class="leaderboard-table">
                  <div id="fifteen" ref="fifteen" class="scroll-view">
                    <v-simple-table fixed-header height="830">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Charity</th>
                          <th>Classes Completed</th>
                          <th>Days Remaining</th>
                        </tr>
                      </thead>
                      <tbody v-if="fifteenList && fifteenList.length > 0">
                        <tr class="body-row" v-for="member in fifteenList" :key="member.name">
                          <td>{{ formatName(member) }} </td>
                          <td><v-img style="max-width: 30px;" :src="require(`../assets/charities/${member.charityId}.png`)" /></td>
                          <td>{{ member.totalClasses }}</td>
                          <td>{{ daysRemaining(member.pledgeStartDate, member.pledgeEndDate) }}</td>
                        </tr>
                      </tbody>
                      <tbody v-if="!fifteenList || fifteenList.length === 0">
                        <td colspan="4" class="text-center">No pledges yet!</td>
                      </tbody>
                    </v-simple-table>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'
import { orderBy } from 'lodash'
import HeartLoader from '../components/HeartLoader.vue'

export default {
  name: 'DashboardPage',

  components: {
    HeartLoader
  },

  data() {
    return {
      tab: null,
      fifteenListTest: [
        {
          "id": 343,
          "dypId": 2,
          "firstName": "Robert",
          "lastName": "Kittleman",
          "phone": null,
          "email": "robert+astros@rayoga.com",
          "marianaTekId": 133148,
          "teamId": null,
          "charityId": 1,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-15T00:00:00.000Z",
          "pledgeEndDate": "2025-07-15T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-26T03:30:52.134Z",
          "updatedAt": "2025-05-26T03:31:12.507Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },{
          "id": 343,
          "dypId": 2,
          "firstName": "Robert",
          "lastName": "Kittleman",
          "phone": null,
          "email": "robert+astros@rayoga.com",
          "marianaTekId": 133148,
          "teamId": null,
          "charityId": 1,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-15T00:00:00.000Z",
          "pledgeEndDate": "2025-07-15T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-26T03:30:52.134Z",
          "updatedAt": "2025-05-26T03:31:12.507Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },{
          "id": 343,
          "dypId": 2,
          "firstName": "Robert",
          "lastName": "Kittleman",
          "phone": null,
          "email": "robert+astros@rayoga.com",
          "marianaTekId": 133148,
          "teamId": null,
          "charityId": 1,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-15T00:00:00.000Z",
          "pledgeEndDate": "2025-07-15T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-26T03:30:52.134Z",
          "updatedAt": "2025-05-26T03:31:12.507Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
        {
          "id": 336,
          "dypId": 2,
          "firstName": "lisa",
          "lastName": "turtl",
          "phone": "9499230297",
          "email": "veesta+9122@rayoga.com",
          "marianaTekId": 131939,
          "teamId": null,
          "charityId": 2,
          "pledgeClasses": 15,
          "pledgeStartDate": "2025-06-25T00:00:00.000Z",
          "pledgeEndDate": "2025-07-25T00:00:00.000Z",
          "totalClasses": 0,
          "isConfirmed": false,
          "isCaptain": false,
          "smsSent": false,
          "hasPaid": true,
          "createdAt": "2025-05-22T17:48:56.357Z",
          "updatedAt": "2025-05-22T18:25:56.901Z",
          "team": null
        },
      ]
    }
  },

  computed: {
    ...mapGetters([
      'isAuthenticated'
    ]),
    user() {
      return this.$store.state.user
    },
    maxDate() {
      return this.$store.state.endDate
    },
    members() {
      return this.$store.state.memberLeaderboard
    },
    memberLeaderboardLoading() {
      return this.$store.state.memberLeaderboardLoading
    },
    memberCount() {
      return (this.members) ? this.members.length : 0
    },
    memberCompletedCount() {
      if (this.members) {
        const count = this.members.filter(member => {
          return (member.totalClasses >= member.pledgeClasses)
        })

        return count.length
      } else {
        return 0
      }
    },
    memberDonationTotal() {
      if (this.members) {
        let total = 0

        this.members.forEach(member => {
          let modifier = 0
          if (member.pledgeClasses === 15) modifier = 10
          if (member.pledgeClasses === 45) modifier = 15
          if (member.pledgeClasses === 75) modifier = 20

          total = total + 10 + modifier
        })

        return total
      } else {
        return 0
      }
    },
    memberTotalClasses() {
      if (this.members) {
        let total = 0

        this.members.forEach(member => {
          total = total + member.totalClasses
        })

        return total
      } else {
        return 0
      }
    },
    fifteenList() {
      if (this.members) {
        const list = this.members.filter(member => member.pledgeClasses === 15)
        return orderBy(list, 'totalClasses', 'desc')
      } else {
        return []
      }
    },
    fortyfiveList() {
      if (this.members) {
        const list = this.members.filter(member => member.pledgeClasses === 45)
        return orderBy(list, 'totalClasses', 'desc')
      } else {
        return []
      }
    },
    seventyfiveList() {
      if (this.members) {
        const list = this.members.filter(member => member.pledgeClasses === 75)
        return orderBy(list, 'totalClasses', 'desc')
      } else {
        return []
      }
    },

  },

  watch: {
    tab(val) {
      const rowHeight = 48
      const baseDuration = 1100
      const baseDelay = 650

      if (val === 0) {
          const duration = this.seventyfiveList.length * baseDuration
          const delay = this.seventyfiveList.length * baseDelay
          setTimeout(() => {
            const height = this.seventyfiveList.length * rowHeight
            const element = this.$el.querySelector('#seventyfive .v-data-table__wrapper')

            this.smoothScroll(element, height, duration)
            setTimeout(() => {
              this.tab = 1
              element.scrollTop = -10
            }, delay + 6000)
          }, 3000)
      }
      if (val === 1) {
        const duration = this.fortyfiveList.length * baseDuration
        const delay = this.fortyfiveList.length * baseDelay
        setTimeout(() => {
            const height = this.fortyfiveList.length * rowHeight
            const element = this.$el.querySelector('#fortyfive .v-data-table__wrapper')

            this.smoothScroll(element, height, duration)
            setTimeout(() => {
              this.tab = 2
              element.scrollTop = -10
            }, delay + 6000)
          }, 3000)
      }
      if (val === 2) {
        const duration = this.fifteenList.length * baseDuration
        const delay = this.fifteenList.length * baseDelay
        setTimeout(() => {
            const height = this.fifteenList.length * rowHeight
            const element = this.$el.querySelector('#fifteen .v-data-table__wrapper')

            this.smoothScroll(element, height, duration)
            setTimeout(() => {
              this.tab = 0
              element.scrollTop = -10
            }, delay + 6000)
          }, 3000)
      }
    },
  },

  methods: {
    daysRemaining(startDate, endDate) {
      const now = DateTime.now()
      const start = DateTime.fromISO(startDate)
      const end = DateTime.fromISO(endDate)
      let diff

      if (start.toMillis() > now.toMillis()) {
        diff = end.diff(start, 'days').toObject()
      } else {
        diff = end.diff(now, 'days').toObject()
      }

      if (diff.days < 0) {
        return 0
      }

      return Math.ceil(diff.days)
    },

    formatName(member) {
      const first = member.firstName
      const last = (member.lastName) ? member.lastName.charAt(0) + '.' : ''

      return `${first} ${last}`
    },
    smoothScroll(element, to, duration) {
      const that = this
      if (duration <= 0) return;
      var difference = to - element.scrollTop;
      var perTick = difference / duration * 24; // 24ms per frame
      var turn = element.scrollTop < to;

      setTimeout(function() {
        element.scrollTop = element.scrollTop + perTick;
        if ((turn && element.scrollTop >= to) || (!turn && element.scrollTop <= to)) {
          element.scrollTop = to;
          return;
        }
        that.smoothScroll(element, to, duration - 16);
      }, 16);
    }
  },

  async beforeMount() {
    //if (!this.isAuthenticated) this.$router.push({ name: 'Home' })
    await this.$store.dispatch('getMemberLeaderboard')
    setInterval(() => {
      this.$store.dispatch('getMemberLeaderboard')
    }, 1000 * 3600)
    window.scrollTo(0, 0);
  },

  mounted() {
  },
}
</script>

<style lang="scss">
.round-block.bluee {
  border-radius: 8px;
  background-color: #1F435D;
  color: #ffffff;

  h1 {
    line-height: 1.1;
  }
}

.custom-tabs {

  .v-tabs-slider-wrapper {
    display: none;
  }

  .v-tab {
    border-top: 2px solid #A9421B;
    border-bottom: 2px solid #A9421B;
    color: #A9421B;
    font-weight: 800;
  }

  .v-tab.v-tab--active {
    background-color: #A9421B;
    color: #ffffff;
  }

  .v-tab:nth-child(2) {
    border-left: 2px solid #A9421B;
    border-radius: 8px 0 0 8px;
  }

  .v-tab:last-child {
    border-right: 2px solid #A9421B;
    border-radius: 0 8px 8px 0;
  }
}

.leaderboard-table {

  .scroll-view {
    margin-top:10px;
    max-height: 830px;
    overflow-y: scroll;
    ::-webkit-scrollbar {
      display: none;
    }
  }

  .v-data-table {
    background-color: transparent;

    thead {
      th {
        border-bottom: 0 !important;
        color: #000000 !important;
      }
    }

    tbody {

      tr.body-row td {
        border-bottom: 0 !important;
        border-color: #ffffff !important;
        font-family: "patrick-hand-sc", sans-serif;
        font-weight: 400;
        font-style: normal;
        text-transform: uppercase;
        text-align: center;
      }

      tr.body-row td:first-child {
        border-radius: 8px 0 0 8px;
      }

      tr.body-row td:last-child {
        border-radius: 0 8px 8px 0;
      }

      tr.body-row td {
        border-bottom: 4px solid #ffffff !important;
      }

      tr.body-row:nth-of-type(odd) {
        background-color: #F2EBDE;
      }

      tr.body-row:nth-of-type(1),
      tr.body-row:nth-of-type(2) {
        background-color: #7EA589;
        color: #ffffff;
      }
    }
  }
}
</style>